module.exports = __webpack_public_path__ + "img/rarity3.04fa201c.png";